module.exports = __webpack_public_path__ + "img/exclamation-point-fill-yellow.a1f233de.svg";